import { SharedFunnelDatalayerEvent } from 'src/app/_services/types/datalayer.types';
import { Step } from 'src/app/_services/types/step.type';
import { LinearStepperElement } from 'src/app/ui-kit/components/linear-stepper/linear-stepper.component';

export const BUSINESS_INSURANCE_FUNNEL_EVENT_BASE: SharedFunnelDatalayerEvent = {
  event: 'Market_Entreprise',
  product_category: 'Entreprise',
  product_name: 'Market',
  funnel_complete: false,
};

export const BUSINESS_INSURANCE_BASE = 'pro';

export const BUSINESS_INSURANCE_STEPS: {
  COMPANY_FORM: Step;
  PRODUCT_FORM: Step;
  OFFERS: Step;
  ACCOUNT: Step;
  LOGIN: Step;
  REGISTER: Step;
  SIGNATURE: Step;
  END: Step;
} = {
  COMPANY_FORM: {
    step: [1, 1],
    url: 'informations-entreprise',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 1,
      stage_name: 'Informations entreprise',
    },
  },
  PRODUCT_FORM: {
    step: [2, 1],
    url: 'informations-produit',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 2,
      stage_name: 'Informations produit',
    },
  },
  OFFERS: {
    step: [3, 1],
    url: 'offres',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 3,
      stage_name: 'Offres',
    },
  },
  ACCOUNT: {
    step: [3, 1],
    url: 'compte',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Compte',
    },
  },
  LOGIN: {
    step: [3, 1],
    url: 'connexion',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Connexion',
    },
  },
  REGISTER: {
    step: [3, 1],
    url: 'inscription',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Inscription',
    },
  },
  SIGNATURE: {
    step: [4, 1],
    url: 'signature',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 6,
      stage_name: 'Signatures',
    },
  },
  END: {
    step: [5, 1],
    url: 'fin',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 7,
      stage_name: 'Fin',
      funnel_complete: true,
    },
  },
};

export const BUSINESS_STEPS_NAMES: LinearStepperElement[] = [
  {
    title: $localize`Informations entreprise`,
  },
  {
    title: $localize`Informations produit`,
  },
  {
    title: $localize`Offres`,
  },
  {
    title: $localize`Signature de contrat`,
  },
  {
    title: $localize`Fin`,
  },
];

export const END_SCREEN_TEXTS: LinearStepperElement[] = [
  {
    title: $localize`Vous allez recevoir un comparatif d'offres (dans les 24h ouvrées)`,
  },
  {
    title: $localize`Votre conseiller LTY vous présente les différentes variantes`,
  },
  {
    title: $localize`Vous validez dans votre espace client la proposition choisie`,
  },
  {
    title: $localize`Votre police est en attente de validation (3 à 10 jours)`,
  },
  {
    title: $localize`Votre police est créée et accessible dans votre Wallet`,
  },
];

export const ONBOARDING_PAGE_SHARED_CONTENT = {
  header: $localize`Gèrez toutes les assurances de votre entreprise, simplement.`,
  keyPoints: [
    $localize`Centralisez vos contrats actuels en un seul espace.`,
    $localize`Visualisez, gèrez vos couvertures et déclarez vos sinistres facilement`,
    $localize`Comparez les primes en quelques clics.`,
    $localize`Obtenez des offres personnalisées adaptées à votre activité.`,
    $localize`Gagnez du temps et maîtrise vos coûts d’assurance.`,
    $localize`Conformité légale garantie pour votre entreprise.`,
  ],
  companyVersion: true,
  cta: $localize`Testez notre solution entreprise en 2 minutes.`,
};
